export default function Clock_Intro() {
  return (
    <div>
      <h1>Clock_Intro Component</h1>
    </div>
  );
}
